import cn from "classnames"

import { Analytics } from "utils/analytics"
import { Text } from "ui-kit/components-branded/index"
import { Icon, IconsName } from "components"
import style from "modules/ClientAccount/components/ReferralLinkWidget/SocialButton/style.module.scss"

interface SocialButtonProps {
    name: string
    link: string
    icon?: IconsName
    iconSize?: number
}

export function SocialButton({ name, link, icon, iconSize = 20 }: SocialButtonProps) {
    return (
        <a
            key={name}
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            className={cn(style.socialButton, "is-fullwidth")}
            onClick={() => {
                if (name === "Telegram" || name === "VKontakte") {
                    Analytics.recommended_block_user_followed_the_link_to_social_network({
                        socialNetwork: name,
                    })
                }
            }}
        >
            {icon ? <Icon type={icon} size={iconSize} /> : ""}
            <Text className="mgl-4">{name}</Text>
        </a>
    )
}
